/**
 * Detalle mensual del resultado: una columna por mes más el acumulado.
 *
 * Solo aparecen los meses CON datos. En la hoja de cálculo, agosto a diciembre
 * ocupaban cinco columnas de ceros y obligaban a leer el ancho antes que las
 * cifras.
 */

import { useState } from "react";
import { formatMoney, formatMonth, moneyClass } from "../../components/format";
import { useClosing } from "./closingContext";
import { StatementHead } from "./shared";

export function MonthlyDetail() {
  const { package: pkg } = useClosing();
  const [acumulado, setAcumulado] = useState(false);
  const { months, rows } = pkg.monthly;

  return (
    <>
      <StatementHead
        title="Detalle del Resultado Integral Mensual"
        subtitle={`del ${pkg.period_from} al ${pkg.period_to}`}
        homologation={pkg.homologation.eri_monthly_detail}
      />

      <div className="toolbar">
        <button
          type="button"
          className={acumulado ? undefined : "primary"}
          onClick={() => setAcumulado(false)}
        >
          Mensual
        </button>
        <button
          type="button"
          className={acumulado ? "primary" : undefined}
          onClick={() => setAcumulado(true)}
        >
          Acumulado
        </button>
        <div className="spacer" />
        <span className="small muted">
          {months.length} {months.length === 1 ? "mes" : "meses"} con movimiento
        </span>
      </div>

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th scope="col">Concepto</th>
                {months.map((month) => (
                  <th key={month} scope="col" className="num">
                    {formatMonth(month)}
                  </th>
                ))}
                <th scope="col" className="num">
                  {acumulado ? "Total" : "Acumulado"}
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => {
                let corrido = 0;
                return (
                  <tr key={row.line_id} className={row.kind === "source" ? undefined : "level-1"}>
                    <td>{row.label}</td>
                    {months.map((month) => {
                      corrido += row.months[month] ?? 0;
                      return (
                        <td
                          key={month}
                          className={
                            // Un encabezado no lleva cifra, así que tampoco
                            // lleva signo: `moneyClass(undefined)` teñiría de
                            // gris una celda vacía.
                            row.kind === "heading"
                              ? "num"
                              : moneyClass(acumulado ? corrido : row.months[month])
                          }
                        >
                          {row.kind === "heading"
                            ? ""
                            : formatMoney(acumulado ? corrido : row.months[month])}
                        </td>
                      );
                    })}
                    <td className={row.kind === "heading" ? "num" : moneyClass(row.total)}>
                      {row.kind === "heading" ? "" : formatMoney(row.total)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
